<template>
  <div class="services">
    <div class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-9.jpg')})`}"
        style="background:no-repeat center center;"
      >
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">移动应用</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">产品信息</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row flex-row">
            <div class="col-sm-8 col-xs-12">
              <h4 class="text-primary">移动应用</h4>
              <h2>微信平台</h2>
              <p>酒店微信公众平台（微官网）是吸引粉丝、培育会员和转化 OTA 客的营销转型升级利器。</p>
              <br />
							<p><i class="fa fa-play"></i> &nbsp;全自助、多功能、一站式服务</p>
							<p><i class="fa fa-play"></i> &nbsp;客人关注酒店公众号并注册会员后，即可通过微信实现订房、选房、支付、导航、连 Wifi 、开锁、开启灯光、调节温度、开启电视、消费查询、点餐、呼叫管家和客服、SOS  、续住、退房等功能，大大方便了宾客使用，给宾客以全新科技体验！</p>
            </div>
						<div class="col-md-4 col-sm-12 align-self-center">
              <img src="../assets/images/career-img-2.jpg" alt />
            </div>
          </div>

          <div class="industris-space-90 sm-hidden"></div>
          <hr />
          <div class="industris-space-90 sm-hidden"></div>

					<div class="row flex-row">
            <div class="col-sm-10 col-xs-12">
              <h2>客房宝</h2>
							<p><i class="fa fa-play"></i> &nbsp;方便服务员在查房是直接录入客人的迷你吧消费、洗衣消费、客房赔偿等。从而避免电话报吧后出现总台和查房员互相推诿扯皮的事情发生</p>
							<p><i class="fa fa-play"></i> &nbsp;方便清扫员在清扫房间后直接进行房态维护，使得其他电脑客户端及时更新当前房态</p>
							<p><i class="fa fa-play"></i> &nbsp;方便检查员在检查房间后直接修改房间的状态及及时录入需要维修的信息，方便其他客户端及时更新信息</p>
            </div>
						<div class="col-md-2 col-sm-12 align-self-center">
              <img src="../assets/images/wx-pos-4.png" alt />
            </div>
          </div>	
					
          <div class="industris-space-90 sm-hidden"></div>
          <hr />
          <div class="industris-space-90 sm-hidden"></div>

          <div class="row flex-row">
            <div class="col-sm-6 col-xs-12">
              <h2>全球鹰</h2>
              <p>全球鹰是PMS软件移动端的窗口，通过手机，不管您在国内还是国外，不分国际，都可以随时随地查看酒店的营业收入、房态实况；还可以查看实时报表，协助客户更好的管理酒店。</p>
							<br>
							<p></p>
            </div>
						<div class="col-sm-3 col-xs-12 col-md-offset-2 align-self-center">
							<swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
								<swiper-slide>
									<img src="../assets/images/wx-pms-1.jpg" alt="">
								</swiper-slide>

								<swiper-slide>
									<img src="../assets/images/wx-pms-2.jpg" alt="">
								</swiper-slide>

								<swiper-slide>
									<img src="../assets/images/wx-pms-3.jpg" alt="">
								</swiper-slide>
							</swiper>
							<div class="swiper-pagination" slot="pagination"></div>
							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</div>						
          </div>		
					
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "services_pos",
	components: { swiper, swiperSlide },
	data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.swiper.slideTo(5, 1000, false);
  },
};
</script>

<style>
.fa-play {
  color: #1a94e6;
}
.swiper {
  text-align: center;
}
.swiper-pagination {
  margin-top: -30px;
  margin-left: 45%;
}
.swiper-slide img:hover {
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/pages/services_pos.vue